export class WorkspaceGcpStorageAccessConfiguration {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "allowedPrincipals",
            "baseName": "allowedPrincipals",
            "type": "Array<WorkspaceAllowedPrincipal>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return WorkspaceGcpStorageAccessConfiguration.attributeTypeMap;
    }
    constructor() {
    }
}
